import SubmissionRequest from '@/models/SubmissionRequest';
import { PaginationMeta, AmFilter } from '../types';
import { PensionScheme } from '../../pensionScheme/types';

export interface IAMDashboardState {
  submissionRequests: SubmissionRequest[];
  amPaginationMeta: PaginationMeta;
  amFilters: AmFilter;
  organizationClients: PensionScheme[];
  syncingSubmissions: Boolean;
}

export const AMDashboardState: IAMDashboardState = {
  submissionRequests: [],
  amPaginationMeta: {} as PaginationMeta,
  organizationClients: [],
  amFilters: {
    statusFilter: '',
    clientIds: [],
    searchKeyword: ''
  },
  syncingSubmissions: false
};
